import {ParamCodeExporter} from '../Param';
import {TypedNumericParam} from '../../../../../../@polygonjs/polygonjs/src/engine/params/_Numeric';
import {ParamType} from '../../../../../../@polygonjs/polygonjs/src/engine/poly/ParamType';

export class ParamNumericCodeExporter extends ParamCodeExporter<TypedNumericParam<ParamType>> {
	override add_main() {
		if (this._param.hasExpression() && this._param.expressionController) {
			const escaped_expression = this._param.expressionController.expression()?.replace(/'/g, "\\'");
			this._lines.push(this.prefix() + `.set('${escaped_expression}')`);
		} else {
			this._lines.push(this.prefix() + `.set(${this._param.value})`);
		}
	}

	override HTMLSnippet() {
		const range = this._param.options.range();
		const stepFloat = this._param.options.step() || 0.01;
		const step = this._param.type() == ParamType.INTEGER ? 1 : stepFloat;
		const id = this._HTMLId(this._param);
		const label = `<label for='${id}'>${id}</label>`;
		const numberInput = `<input type='number' id='${id}' name='${id}' min=${range[0] || 0} max=${
			range[1] || 1
		} step=${step} value=${this._param.value}></input>`;
		// const rangeInput = `<input type='range' id='${this._HTMLId()}' name='${this._HTMLId()}' min=${
		// 	range[0] || 0
		// } max=${range[1] || 1} step=${step} value=${this._param.value}></input>`
		return `${label}
${numberInput}`;
	}
	override JSSnippet() {
		const id = this._HTMLId(this._param);
		return `document.getElementById('${id}').addEventListener('input', function(event){
	scene.node('${this._param.node.path()}').p.${this._param.name()}.set(event.target.value);
})`;
	}
}
